import React from 'react';

const ContentInsertTextContext = React.createContext<{
	interactionEnabled: boolean;
}>({
	interactionEnabled: false,
});

export default ContentInsertTextContext;
